'use client';

/**
 * Utility to mark text that comes from mock data
 * This helps distinguish between real backend data and mock data
 */

import { cssVars } from '@/styles/theme';
import React from 'react';

interface MockDataMarkerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Component that wraps text with a "mock data" marker
 */
export function MockDataMarker({ children, className = '' }: MockDataMarkerProps) {
  return (
    <span className={className}>
      <span
        className="me-1 inline-block rounded px-1.5 py-0.5 text-xs font-semibold"
        style={{
          backgroundColor: cssVars.accent.light,
          color: cssVars.secondary.darker,
          border: `1px solid ${cssVars.accent.warm}`,
        }}
        title="Mock Data"
      >
        [Mock Data]
      </span>
      {children}
    </span>
  );
}

/**
 * Helper function to wrap text with mock data marker
 */
export function markMockData(text: string | number | undefined | null): React.ReactNode {
  if (text === undefined || text === null) return text;
  return <MockDataMarker>{String(text)}</MockDataMarker>;
}

/**
 * Helper function to check if we should mark data as mock
 * This can be used to conditionally mark data based on USE_MOCKS flag
 */
export function shouldMarkAsMock(): boolean {
  // Import dynamically to avoid circular dependencies
  try {
    const { USE_MOCKS } = require('../api/_mockHelper');
    return USE_MOCKS;
  } catch {
    return false;
  }
}
